<ng-container *ngIf="element.type === 140 || element.type === 160 && element.values.length > 0">
    <div class="simple-text-wrapper" *ngFor="let value of emailPhoneValues">
        <strong class="label">{{ getLabelForSpecificFields(value) | htmlDecode }}</strong>
        <span>{{ getTextForSpecificFields(value) }}</span>
    </div>
</ng-container>

<ng-container *ngIf="element.type !== 140 && element.type !== 160">
    <div class="simple-text-wrapper">
        <strong class="label">{{ getLabel() | htmlDecode }}</strong>
        <ng-container *ngIf="element.type === 2 && element.currency && element.value.length > 0">
            <div class="price-field-wrapper">
                <span>{{getCurrencySymbol()}}{{ getText() }}</span>
            </div>
        </ng-container>
        <ng-container *ngIf="element.type === 2 && !element.currency && element.value.length > 0">
            <div class="price-field-wrapper">
                <span>{{ getText() }}</span>
            </div>
        </ng-container>
        <ng-container *ngIf="element.type !== 2">
            <span>{{ getText() }}</span>
        </ng-container>
    </div>
</ng-container>